import React from 'react';
import { Select, Option, ClusterLayout, Text } from '@mc/wink';
import { mcdsFlagCheck } from '@mc/wink/helpers/utils-ts';
import { TranslateResultsPerPage } from './TranslateResultsPerPage';

const getPaginationRangeText = (
  currentPage: number,
  itemsPerPage: number,
  totalItems: number,
) => {
  const startItem = Math.min((currentPage - 1) * itemsPerPage + 1, totalItems);
  const endItem = Math.min(currentPage * itemsPerPage, totalItems);
  return `${startItem}-${endItem}`;
};

export type ResultsPerPageProps = {
  onChange: (value: number) => void;
  itemsPerPage: number;
  totalItems: number;
  currentPage: number;
  perPageOptions: number[];
};

const ResultsPerPage = ({
  onChange,
  itemsPerPage,
  currentPage,
  totalItems,
  perPageOptions,
}: ResultsPerPageProps) => {
  const { ofText, resultsText } = TranslateResultsPerPage(totalItems);
  const rangeText = getPaginationRangeText(
    currentPage,
    itemsPerPage,
    totalItems,
  );

  const isReleased = mcdsFlagCheck(
    'xp_mcds_redesign_components_organisms_part_2',
  );

  const handleOnChange = (value: $TSFixMe) => {
    onChange(value as number);
  };

  return (
    isReleased && (
      <ClusterLayout gap={3}>
        <Select
          label={resultsText}
          hideLabel
          size="medium"
          mode="listbox"
          value={itemsPerPage}
          renderSelectedValue={() => {
            return `${itemsPerPage} / page`;
          }}
          onChange={handleOnChange}
        >
          {perPageOptions.map((perPage) => (
            <Option key={perPage} value={perPage} label={perPage.toString()}>
              {perPage}
            </Option>
          ))}
        </Select>
        <div role="status" aria-live="polite">
          <Text as="span" appearance="small">
            {rangeText}
          </Text>
          <Text as="span" appearance="small-tertiary">
            {ofText}
          </Text>
          <Text as="span" appearance="small">
            {totalItems}
          </Text>
        </div>
      </ClusterLayout>
    )
  );
};

export default ResultsPerPage;
